<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            打卡地点
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled='disabledEdit' @click.native="toggleModalEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入地点名称" v-model="name" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-select
                            v-model="status">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" highlight-current-row @row-click="rowClick" border style="width: 100%;">

                        <el-table-column prop="name" label="地点名称"></el-table-column>

                        <el-table-column prop="radius" label="考勤半径(米)"></el-table-column>

                        <el-table-column prop="startTimeSpanLate" label="迟到时间范围(/分)"></el-table-column>

                        <el-table-column prop="status" label="状态">
                             <template slot-scope="scorp">
                                <span v-if="scorp.row.status==1">正常</span>
                                <span v-if="scorp.row.status==2">废弃</span>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title="巡逻点二维码" :visible.sync="dialogVisible" width="400px" center>
            <div style="justify-content: center;display: flex;">
                <div class="canvas-code" id="qrcode" ></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="refresh">刷 新</el-button>
            </span>
        </el-dialog>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import QRCode  from "qrcodejs2"
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                showModalEdit:false,
                dialogVisible:false,
                searchDishes:'',
                row:'',
                name:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:1},{name:'禁用',value:2}]
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleQrcode(row){
                this.dialogVisible=true
                this.row=row
                let qrcode=document.getElementById("qrcode")
                if(qrcode){
                    document.getElementById("qrcode").innerHTML = "";
                }
                var code=row.patrolPointCode+'&'+row.updateTime
                this.$nextTick (function () {
                    this.qrcodeInit(code);
                })
            },
            refresh(){
                this.$confirm('确认刷新？')
                .then(() => {
                    this.setBank()
                    
                })
                .catch(()=> {});
            },
            setBank(){
                var row=this.row
                var updateTime=new Date();
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PatrolPoint/Edit",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:row.name,
                        lon:row.lon,
                        lat:row.lat,
                        updateTime:updateTime,
                        status:row.status,
                        patrolPointCode:row.patrolPointCode
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        let qrcode=document.getElementById("qrcode")
                        if(qrcode){
                            document.getElementById("qrcode").innerHTML = "";
                        }
                        updateTime=JSON.stringify(updateTime)
                        var code=row.patrolPointCode+'&'+JSON.parse(updateTime)
                        this.$nextTick (function () {
                            this.qrcodeInit(code);
                        })
                        this.getList()
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            qrcodeInit (code) {
                new QRCode('qrcode', {
                    width: 250,
                    height: 250,        // 高度
                    text:  code,   // 二维码内容
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                })
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinPoint/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.disabledEdit=true
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            rowClick(row){
                this.row=row
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
            }



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }

</style>
